import { Schema } from '@livestore/utils/effect'

import { EventSequenceNumber } from '../schema/mod.ts'

export class IsOfflineError extends Schema.TaggedError<IsOfflineError>('~@livestore/common/IsOfflineError')(
  'IsOfflineError',
  {
    cause: Schema.Defect,
  },
) {}

/** Unique ID generated by the backend when its created. Used to check whether the backend identity has changed. */
export const BackendId = Schema.String.annotations({ title: '@livestore/sync-cf:BackendId' })

export class BackendIdMismatchError extends Schema.TaggedError<BackendIdMismatchError>(
  '~@livestore/common/BackendIdMismatchError',
)('BackendIdMismatchError', {
  expected: BackendId,
  received: BackendId,
}) {}

export class ServerAheadError extends Schema.TaggedError<ServerAheadError>('~@livestore/common/ServerAheadError')(
  'ServerAheadError',
  {
    minimumExpectedNum: EventSequenceNumber.Global.Schema,
    providedNum: EventSequenceNumber.Global.Schema,
  },
) {}
